export default {
	meters: {
		meter_details: 'Meter details',
		meter_number: 'Meter number',
		licensed_by: 'Licensed by',
		meter_type: 'Meter type',
		responsible_for_measurement: 'Responsible for measurement',
		type_of_reading: 'Type of measurement',
		removed_at: 'Removed at',
		manufacturer: 'Manufacturer',
		installed_on: 'Installed on',
		model_year: 'Model year',
		calibration_due_on: 'Calibration due on',
		zeroable: 'Zeroable',
		consumption_information: 'Consumption information',
		record_reading: 'Record reading',
	},
}
